import { render, staticRenderFns } from "./CRS.Detail.vue?vue&type=template&id=ca6dcbbe&"
import script from "./CRS.Detail.vue?vue&type=script&lang=js&"
export * from "./CRS.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports